import { Pipe, PipeTransform } from '@angular/core';
import { Choice } from '@liberty-financial/ng-components';

@Pipe({
  name: 'choiceOption'
})
export class ChoiceOptionPipe implements PipeTransform {
  transform(options: string[]): Choice[] {
    return options.map((o) => ({ label: o, value: o }));
  }
}
